import React, { forwardRef } from 'react';
import { ButtonProps, Button } from '@mui/material';
import { Link, LinkProps } from 'react-router';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import style from './index.module.scss';
import clsx from 'clsx';

type Props<D extends React.ElementType, P = {}> = ButtonProps<D, P> & {};
const ButtonRedirectComponent = <D extends React.ElementType = typeof Link, P = LinkProps>(
  props: Props<D, P>,
  ref: ForwardedRef<HTMLButtonElement>,
) => {
  return (
    <Button
      component={Link}
      variant="outlined"
      color="secondary"
      endIcon={<OpenInNewIcon />}
      ref={ref}
      {...props}
      className={clsx(style.root, props.className)}
    />
  );
};

// React 19 types: a JSX component takes one argument, so the generic signature is restated with the ref as a prop
export const ButtonRedirect = forwardRef<HTMLButtonElement, Props<typeof Link, LinkProps>>(
  ButtonRedirectComponent,
) as <D extends React.ElementType = typeof Link, P = LinkProps>(
  props: Props<D, P> & React.RefAttributes<HTMLButtonElement>,
) => React.ReactElement;
